import { Countdown } from "./Countdown"
import { CustomButton } from "../global/CustomButton"
import "./boomboxSection.css"

export function BoomboxSection(){
    return (
        <div className="d-flex boombox-section align-items-center bg-black px-5">

            <div className="d-flex flex-column gap-3 py-5 boombox-details">
                <p className="categories">Categories</p>
                <p className="heading text-white">
                    Enhance Your<br />
                    Music Experience
                </p>
                <Countdown countdownDate={new Date("October 8 2025 00:00:00").getTime()} />
                <CustomButton
                    btnLink={true}
                    path="/shop"
                    text="Buy Now!"
                    color="secondary"
                />
            </div>

            <div className="d-flex cntr position-relative bbox-img-section">
                <div className="position-absolute glowing-circle rounded-circle"></div>
                <div className="d-flex position-absolute cntr w-100 h-100 boombox-image"></div>
            </div>

        </div>
    )
}